import { Injectable, inject, signal } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
    private swUpdate = inject(SwUpdate);
    public readonly updateAvailable = signal<boolean>(false);

    constructor() {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.versionUpdates.pipe(
                filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY')
            ).subscribe(() => {
                this.updateAvailable.set(true);
            });
        }
    }

    // Force the app to download and activate the latest version
    public applyUpdate(): void {
        this.swUpdate.activateUpdate().then(
            () => window.location.reload()
        );
    }

    public dismissUpdate() {
        this.updateAvailable.set(false);
    }
}
